<div class="card widget-overview-box widget-overview-box-1">
    <div class="flex justify-content-between">
        <div>
            <span class="overview-title">{{title}}</span>
        </div>
        <div>
            <i class="pi pi-info-circle ml-2" *ngIf="toolTipPath" pTooltip="{{toolTipPath}}"></i>
        </div>
    </div>
    <p-divider type="solid" />
    <div class="overview-detail">
        <p-table [value]="tableData"
                 [scrollable]="true"
                 scrollHeight="200px"
                 [sortField]="sortField"
                 [sortOrder]="sortOrder"
                 (onSort)="onSort($event)">
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="country">Country</th>
                    <th pSortableColumn="city">City</th>
                    <th pSortableColumn="sessions">Sessions</th>
                    <th pSortableColumn="activeUsers">Active Users</th>
                    <th pSortableColumn="newUsers">New Users</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
                <tr>
                    <td>{{row.country}}</td>
                    <td>{{row.city}}</td>
                    <td>{{row.sessions}}</td>
                    <td>{{row.activeUsers}}</td>
                    <td>{{row.newUsers}}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="footer" *ngIf="totals">
                <tr>
                    <td colspan="2">Totals</td>
                    <td>{{totals.totalSessions}}</td>
                    <td>{{totals.totalActiveUsers}}</td>
                    <td>{{totals.totalNewUsers}}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="5">No data available</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <img *ngIf="showUpDwnImg" src="assets/layout/images/dashboard/rate.svg">
</div>
